import {
  CLEAR_SUCCESSFUL_BOOKING_DATA,
  BOOKING_RESPONSE_RECEIVED,
  BOOKING_REQUEST_SUBMITTED,
  BOOKING_REQUEST_NOT_SUBMITTED,
  BOOKING_REQUEST_FAILED,
  BOOKING_CLEAR_ERRORS,
  BOOKING_TIME_SELECTED,
  BOOKING_INSURANCE_TYPE,
  PATIENT_TYPE_CHANGED,
  SYMPTOM_CLICKED,
  SYMPTOM_UPDATED,
  BOOKING_REASON_FOR_VISIT_CHANGED,
  BOOKING_REQUESTED_TIME_CHANGED,
  BOOKING_RECEIVE_USER_PROFILE,
  BOOKING_SET_LOCATION_ID,
  BOOKING_ORIGIN_CHANGED,
  BOOKING_NOTES,
  BOOKING_APPOINTMENT_TYPE,
  BOOKING_SET_IS_EXISTING_PATIENT,
  BOOKING_SET_HAS_BOOKED_HERE_BEFORE_WITH_SOLV,
} from '../constants';
import { analyticsTrackEvent } from '../core/analytics';
import { APP_API_FAILURE } from '../core/analytics/events';

const clearSuccessfulBookingData = () => ({
  type: CLEAR_SUCCESSFUL_BOOKING_DATA,
});

const bookingRequestSubmitted = value => ({
  type: BOOKING_REQUEST_SUBMITTED,
  payload: { value },
});

const bookingRequestNotSubmitted = value => ({
  type: BOOKING_REQUEST_NOT_SUBMITTED,
  payload: { value },
});

const bookingResponseReceived = value => ({
  type: BOOKING_RESPONSE_RECEIVED,
  payload: { value },
});

const bookingFailed = value => {
  analyticsTrackEvent(APP_API_FAILURE);
  return {
    type: BOOKING_REQUEST_FAILED,
    payload: { value },
  };
};

const clearBookingErrors = () => ({
  type: BOOKING_CLEAR_ERRORS,
});

const bookingTimeSelected = appointmentTime => ({
  type: BOOKING_TIME_SELECTED,
  payload: { appointmentTime },
});

const setIsExistingPatient = value => ({
  type: BOOKING_SET_IS_EXISTING_PATIENT,
  payload: { value },
});

const setHasBookedHereBeforeWithSolv = value => ({
  type: BOOKING_SET_HAS_BOOKED_HERE_BEFORE_WITH_SOLV,
  payload: { value },
});

const setInsuranceType = value => ({
  type: BOOKING_INSURANCE_TYPE,
  payload: { value },
});

const setReasonForVisit = value => ({
  type: BOOKING_REASON_FOR_VISIT_CHANGED,
  payload: { value },
});

const setOrigin = value => ({
  type: BOOKING_ORIGIN_CHANGED,
  payload: { value },
});

const patientTypeChanged = value => ({
  type: PATIENT_TYPE_CHANGED,
  payload: { value },
});

const symptomClicked = value => ({
  type: SYMPTOM_CLICKED,
  payload: { value },
});

const symptomUpdated = value => ({
  type: SYMPTOM_UPDATED,
  payload: { value },
});

const requestedAppointmentTimeChanged = value => ({
  payload: { value },
  type: BOOKING_REQUESTED_TIME_CHANGED,
});

const receiveUserProfileForNewBooking = value => ({
  type: BOOKING_RECEIVE_USER_PROFILE,
  payload: { value },
});

const setLocationId = value => ({
  type: BOOKING_SET_LOCATION_ID,
  payload: { value },
});

const setBookingNotes = value => ({
  type: BOOKING_NOTES,
  payload: { value },
});

const setAppointmentType = value => ({
  type: BOOKING_APPOINTMENT_TYPE,
  payload: { value },
});

export {
  clearSuccessfulBookingData,
  setReasonForVisit,
  requestedAppointmentTimeChanged,
  bookingRequestSubmitted,
  bookingRequestNotSubmitted,
  bookingResponseReceived,
  bookingFailed,
  clearBookingErrors,
  bookingTimeSelected,
  setIsExistingPatient,
  setHasBookedHereBeforeWithSolv,
  setInsuranceType,
  patientTypeChanged,
  symptomClicked,
  symptomUpdated,
  receiveUserProfileForNewBooking,
  setLocationId,
  setOrigin,
  setBookingNotes,
  setAppointmentType,
};
